import { render, staticRenderFns } from "./EzBannerButton.vue?vue&type=template&id=d8e4d6a8&"
import script from "./EzBannerButton.vue?vue&type=script&lang=js&"
export * from "./EzBannerButton.vue?vue&type=script&lang=js&"
import style0 from "./EzBannerButton.vue?vue&type=style&index=0&id=d8e4d6a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports